import { Image, Page, Text, View } from '@react-pdf/renderer';
import { FC, PropsWithChildren, ReactNode } from 'react';
import logo from '../../../assets/logo.png';

interface Props extends PropsWithChildren {
  brandLogoUrl: string | null;
  pageNumber: number;
  pageCount: number;
  topRightSection?: ReactNode;
}

export const PdfContainer: FC<Props> = ({ children, pageNumber, pageCount, brandLogoUrl, topRightSection }) => {
  return (
    <Page size="A4">
      <View
        style={{
          paddingLeft: 15,
          paddingRight: 15,
          paddingBottom: 10,
          paddingTop: 10,
          height: '100%',
          position: 'relative'
        }}
      >
        {pageNumber === 1 && (
          <View style={{ marginBottom: 30, flexDirection: 'row' }}>
            <View style={{ width: 150, height: 30, marginRight: 50, marginLeft: 20, marginTop: 20 }}>
              <Image
                source={brandLogoUrl ? brandLogoUrl : logo}
                style={{
                  width: '100%',
                  height: '100$',
                  objectFit: 'contain'
                }}
              />
            </View>

            {topRightSection && topRightSection}
          </View>
        )}
        <View>{children}</View>
        <View
          style={{
            bottom: 10,
            left: 40,
            padding: '0px',
            position: 'absolute',
            width: '100%'
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              fontSize: 8,
              alignItems: 'center'
            }}
          >
            <Text
              style={{
                marginRight: 110
              }}
            >{`Page ${pageNumber} of ${pageCount}`}</Text>

            {brandLogoUrl && pageCount === pageNumber && (
              <View
                style={{
                  flexDirection: 'row',
                  fontSize: 8,
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Text style={{ fontSize: 12, marginRight: 10 }}>Powered by:</Text>
                <View style={{ width: 150, height: 30 }}>
                  <Image source={logo} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
    </Page>
  );
};
